<template>
  <div class="button_area base_btn">
    <button
      class="active btnB"
      :class="bottom"
      :type="type"
      :disabled="disabled"
      @click.stop="$emit('click')"
    >
      {{ name }}
    </button>
  </div>
</template>

<script>
export default {
  name: "BaseButton",
  props: {
    name: {
      type: String,
    },
    type: {
      type: String,
      default: "button",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    bottom: {
      type: String,
      default: "",
    },
  },
};
</script>
